export default __webpack_public_path__ + "static/media/grid-icon.926b3866.svg";